module.exports = __webpack_public_path__ + "img/apple_pick_ladder_sit_q90_lossy.40efa004.webp";